import { useEffect, useState } from "react";
import { authFetch } from "../../../api";
import RoadmapIntro from "./RoadmapIntro";
import PremiumAccess from "../../components/PremiumAccess/PremiumAccess";
import PersonalityResultCard from "./PersonalityResultCard";
import AlmostReady from "./AlmostReady";

const SAP_TimeLine = () => {
  const userId = localStorage.getItem("userId");
  const [isEnrolled, setIsEnrolled] = useState(false);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  const fetchCheckGivenQuiz = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;

      const response = await authFetch("quiz/check-personality-quiz-status", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });

      const data = await response.json();
      setAlreadySubmitted(!!data?.success);
    } catch (err) {
      console.log(err);
    }
  };

  const CheckEnrolled = async () => {
    try {
      const response = await authFetch(`packages/get-enrolled-packages`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });

      const data = await response.json();
      if (data?.data?.length > 0) {
        setIsEnrolled(true);
      } else {
        setIsEnrolled(false);
      }
      console.log("C", data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCheckGivenQuiz();
    CheckEnrolled();
  }, []);

  const showPremium = !isEnrolled;

  const showRoadmap = isEnrolled && !alreadySubmitted;

  const showResult = isEnrolled && alreadySubmitted;

  const showAlmostReady = !showPremium && !showRoadmap && !showResult;

  return (
    <div>
      {showPremium && <PremiumAccess />}
      {showRoadmap && <RoadmapIntro />}
      {showResult && <PersonalityResultCard />}
      {showAlmostReady && <AlmostReady />}
    </div>
  );
};

export default SAP_TimeLine;
